import {UsersAcceptInvitationTypes} from "../Users.acceptInvitation/Users.acceptInvitation.types";
import {UsersInviteTypes} from "../Users.invite/Users.invite.types";

export const UserInfoFormTypes = {...UsersAcceptInvitationTypes, ...UsersInviteTypes};